import { Eye } from "lucide-react";
import { MODE_META } from "./constants";

export default function CoverModeTabs({
  activeMode,
  onSelect,
  isCoverOn,
  siteMode,
  onActivate,
  togglingSite,
}) {
  return (
    <>
      <div
        className="inline-flex rounded-xl border border-slate-200 bg-white p-1 shadow-sm"
        data-testid="admin-cover-tabs"
      >
        {Object.entries(MODE_META).map(([mode, meta]) => {
          const Icon = meta.icon;
          const isActive = mode === activeMode;
          const isLive = isCoverOn && siteMode === mode;
          return (
            <button
              key={mode}
              type="button"
              onClick={() => onSelect(mode)}
              data-testid={`admin-cover-tab-${mode}`}
              className={`inline-flex items-center gap-2 rounded-lg px-3.5 py-1.5 text-sm transition-colors ${
                isActive
                  ? "bg-slate-900 text-white"
                  : "text-slate-600 hover:bg-slate-50"
              }`}
            >
              <Icon className="h-3.5 w-3.5" /> {meta.label}
              {isLive && (
                <span
                  className="ml-1 inline-flex items-center gap-1 rounded-full bg-emerald-500/15 px-1.5 py-0.5 text-[10px] font-medium text-emerald-300"
                  data-testid={`admin-cover-tab-${mode}-live-badge`}
                >
                  <span className="inline-block h-1.5 w-1.5 rounded-full bg-emerald-400" />
                  Live
                </span>
              )}
            </button>
          );
        })}
      </div>

      <div className="flex flex-wrap items-center justify-between gap-3">
        <p
          className="text-sm text-slate-500"
          data-testid="admin-cover-mode-desc"
        >
          {MODE_META[activeMode].description}
        </p>
        {isCoverOn && siteMode !== activeMode && (
          <button
            type="button"
            onClick={onActivate}
            disabled={togglingSite}
            className="inline-flex items-center gap-1.5 rounded-lg border border-slate-200 bg-white px-3 py-1.5 text-xs font-medium text-slate-700 hover:bg-slate-50 disabled:opacity-50"
            data-testid="admin-cover-activate-button"
          >
            <Eye className="h-3 w-3" /> Show this mode to visitors
          </button>
        )}
      </div>
    </>
  );
}
